module.exports = __webpack_public_path__ + "static/media/alfa_3.0c0a942f.mp4";